import { LOAD, LOAD_SUCCESS, LOAD_FAIL } from 'redux/actions/reportAction';

const initialState = {
  loaded: false,
  loading: false,
  reports: [],
};

function reportReducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        reports: action.payload.data,
      };

    case LOAD_FAIL:
      return {
        ...state,
        loaded: false,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}

export default reportReducer;
